<template>
  <report-section title="脉率趋势图">
    <template v-slot:content>
      <div>
        <div
          :id="title"
          :style="`width: 970px; height: ${220 * zoom}px ;zoom:${
            1 / zoom
          };transform:scale(${zoom});transform-origin:0 0`"
        ></div>
      </div>
    </template>
  </report-section>
</template>
          
<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import { DateTool } from "@js/date-tool.js";
export default {
  components: {
    ReportSection,
  },

  props: {
    reportDetailModel: Object,
  },

  data() {
    return {
      title: "pulse-section-trend-chart",
      zoom: 1,
      chart: undefined,
    };
  },

  mounted() {
    //解决tooltip偏移问题（结合chart的style）
    const app = document.getElementById("app");
    this.zoom = window.getComputedStyle(app, null).zoom;
    this.chart = this.$echarts.init(document.getElementById(this.title));
    this.drawLine();
  },

  watch: {
    reportDetailModel() {
      this.drawLine();
    },
  },

  methods: {
    drawLine() {
      this.chart.setOption({
        grid: [
          {
            right: 20,
            left: 60,
            top: 40,
            bottom: 60,
          }
        ],
        xAxis: [
          {
            type: "time",
            axisLine: {
              lineStyle: {
                color: "#BABABA",
              },
            },
            splitLine: {
              show: true,
            },
            gridIndex: 0,
          }
        ],
        yAxis: [
          {
            name: "脉率趋势图(bpm)",
            type: "value",
            min: 45,
            max: this.reportDetailModel?.reportDetail?.maxPr || 120,
            axisLine: {
              lineStyle: {
                color: "#BABABA",
              },
            },
            gridIndex: 0,
          }
        ],
        series: [
          {
            name: "脉率",
            type: "line",
            symbol: "none",
            data: this.reportDetailModel?.pulseTrandArray || [],
            lineStyle: {
              width: 1,
            },
            color: "#68B680",
            xAxisIndex: 0,
            yAxisIndex: 0,
          }
        ],
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: (params) => {
            return this.formatterToolTip(params);
          },
        },
      });
    },

    formatterToolTip(params) {
      var tip = "";
      params.forEach((item, index) => {
        if (index == 0) {
          const timeStr = DateTool.millisecondTimestampToStr(
            item.data[0],
            "Y_M_D h:m:s"
          );
          tip += timeStr + "<br />";
        }
        const marker = item.marker;
        const seriesName = item.seriesName;
        let value = item.value[1];
        let unit = "bpm";
        
        tip += marker + seriesName + ": " + value + unit + "<br />";
      });
      return tip;
    },
  },
};
</script>
          
<style lang="scss" scoped>
.line-chart {
  @include z-index-2;
  width: 970px !important;
  height: 220px;
  box-sizing: border-box;
}
</style>